import LogRocket from 'logrocket';
import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  componentDidCatch(error, info) {
    this.setState({ error: true });
    LogRocket.captureException(error);
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <div className="error-boundary-container">
        <p>{`There was an error in loading the ${this.props.componentName ? this.props.componentName : 'page'} `}</p>
        <a
          href="_blank"
          style={{ marginRight: 3 }}
          onClick={(e) => {
            e.preventDefault();
            window.location.reload();
          }}
        >
          Reload this page
        </a>
        <p>or return home</p>
        <a href={'/dashboard'}>Home</a>
      </div>
    );
  }
}
